// CURRENT-1487: flatten the orchestrator's per-item error payload
// (e.g. `[{ id, customer_limit: ["You can order this item only N times"] }]`)
// into a list of readable messages.
//
// The checkout's error renderer previously took `messages[0]` as a
// string and produced "Items [object Object]" when the value was an
// array of per-item error objects rather than an array of strings.
// Callers should route any `items`-shaped error array through here.
//
// Each input element is one cart_item's error bag. Keys are field
// names (e.g. `customer_limit`, `inventory`, `available_in_country`)
// pointing to a string array. The `id` field is metadata and is
// skipped so it doesn't leak into the displayed message.
export function flattenPerItemErrors(messages: unknown[]): string[] {
  const out: string[] = [];
  for (const item of messages) {
    if (!item || typeof item !== "object") continue;
    for (const [field, value] of Object.entries(
      item as Record<string, unknown>,
    )) {
      if (field === "id") continue;
      if (Array.isArray(value)) {
        for (const msg of value) {
          if (typeof msg === "string" && msg.length > 0) out.push(msg);
        }
      } else if (typeof value === "string" && value.length > 0) {
        out.push(value);
      }
    }
  }
  return out;
}
